(ns app.front.ui.placeholder-button
  (:require [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.util.util :as util]))

(def dashed-classes "border-2 border-dashed")

(def dashed-classes-gray
  (str/join " " [dashed-classes
                 "border-gray-400 hover:bg-gray-100"]))

(def dashed-classes-violet
  (str/join " " [dashed-classes
                 "border-ui-violet hover:bg-ui-violet"]))

(defn placeholder-button
  "A different take on the classic dashed-button."
  [{:keys [title on-click class icon bg-class disabled? icon-leading? circled-icon? data-cy uppercase?]}]
  (let [icon         (when icon
                       (cc/icon (util/mmap {:class-name  "dashed-button--icon"
                                            :height      "14px"
                                            :description ""
                                            :aria-hidden true}
                                           icon)))
        icon-element (if (and icon circled-icon?)
                       [:span.w-6.h-6.shrink-0.rounded-full.border.border-current.flex.items-center.justify-center
                        icon]
                       icon)
        uppercase?   (not= false uppercase?)]
    [:button.p-3.w-full.rounded.text-ui-violet.hover:text-ui-white.font-bold.flex.gap-2.items-center.justify-center.disabled:cursor-not-allowed.disabled:opacity-50.disabled:hover:bg-white.disabled:hover:text-ui-violet
     {:type     "button"
      :on-click on-click
      :disabled disabled?
      :data-cy  data-cy
      :class    [class
                 (or bg-class "bg-white")
                 dashed-classes-violet
                 (if uppercase? "uppercase" "normal-case")]}
     (when icon-leading? icon-element)
     title
     (when-not icon-leading? icon-element)]))
